import { Component, inject, Inject, PLATFORM_ID, signal } from '@angular/core';
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { Router, RouterLink } from '@angular/router';
import { SupabaseService } from "../shared/services/supabase.service";
import { KpiPopupComponent } from "../kpi-popup/kpi-popup.component";
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [
    CommonModule,
    RouterLink,
    KpiPopupComponent,
  ]
})
export class HeaderComponent {
  protected readonly window: Window | null;
  protected supabase = inject(SupabaseService);
  private router = inject(Router);

  kpiOpen = signal(false);

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.window = isPlatformBrowser(this.platformId) ? window : null;
  }

  async logout() {
    await this.supabase.signOut();
    this.router.navigate(['/sign-in']);
  }
}
